import React from "react";
import { BlockWrapper } from "@smartfire/js-block-engine";
import background from "./assets/background.webp";
import Button from "../button/block";
import style from "./block.module.scss";

function Block({ homeUrl }) {
  return (
    <BlockWrapper.Div
      className={style.block}
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className={style.overlay} />

      <div className={style.content}>
        <div className={style.codeError}>404</div>

        <p className={style.title}>
          Perdu dans le brouillard ? Cette page n'existe pas.
        </p>

        <p className={style.description}>
          Essayez un autre sentier pour continuer votre aventure.
        </p>

        <Button
          text={"Revenir sur la page d'accueil"}
          buttonColor={style.pink}
          mode={"filled"}
          color={style.white}
          link={homeUrl}
        />
      </div>
    </BlockWrapper.Div>
  );
}

export default Block;
